var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('square-box',{attrs:{"focused":_vm.selected,"checked":_vm.completed,"name":_vm.job.name},on:{"onEditClick":function($event){_vm.$emit('editionClick', _vm.job)},"onDeleteClick":_vm.onDeleteClick}}),_vm._v(" "),_c('p-confirm-dialog',{ref:"confirmDialog"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1b54bf4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/job-list/guideline-model-job-item.vue
// module id = 2644
// module chunks = 17